<template>
    <div class="error-message" style="margin-top:18px">
        <!-- <Icon :type="icon" /> -->
        <!-- <span v-else-if="this.$route.name=='drawlist'">暂无更多活动</span> -->
        <span>{{text}}</span>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'error-message',
        props: {
            text: {
                type: String,
                default: '暂无数据'
            },
            icon: {
                type: String,
                default: 'md-warning'
            }
        }
    }
</script>
<style lang="less" scoped>
    .error-message {
        display: flex;
        flex-direction: column;
        align-items: center;
        @size: 1.5rem;
        color: #9e9e9e;
        padding-bottom: 12px;

        .ivu-icon {
            text-align: center;
            width: @size;
            height: @size;
            line-height: @size;
            font-size: @size * .8;
            color: #d9b581;
            opacity: .5;
        }

        span {
            font-size: .6rem;
        }
    }
</style>